import axios from "axios";

const chartsBaseURL = `/api/v1/charts`;

const fetch = () => axios.get(chartsBaseURL);

const create = payload => axios.post(chartsBaseURL, payload);

const update = (id, payload) => axios.put(`${chartsBaseURL}/${id}`, payload);

const destroy = id => axios.delete(`${chartsBaseURL}/${id}`);

const fetchTable = sql_query =>
  axios.post(`${chartsBaseURL}/fetch_table`, { chart: { sql_query } });

const chartsApi = {
  fetch,
  create,
  update,
  destroy,
  fetchTable,
};

export default chartsApi;
